<template>
  <div class="about">
    <h1>This project built with:</h1>
	<ul class="tools">
		<li>Vue 3</li>
		<li>Typescript</li>
		<li>Json Placeholader API</li>
		<h2>Next:</h2>
		<li>Composition API</li>
		<li>Suspense: still experimental and shouldn't be used in production</li>
		<li>Unit Test</li>
	</ul>
  </div>
</template>

<style lang="scss" scoped>
.tools {
	max-width: 500px;
    margin: auto;
    text-align: left;
}
</style>
